import React from 'react'
import '../../assets/css/breadcrumb.css';

const  BreadCrombStyle = {
    "textDecoration": 'none',
    tabindex: "0"
  };

const BreadCrumb = ({Content1, Content2, Content3}) => 
        <section className="main w_breadcrumb large-mw-none" role="region">
            <div className="cmb-container">
                <div className="row ">
                    <ul type="none" style={{display: 'flex'}} className="tiny-12" aria-label="breadcrumbs" role="list">
                        <li><a className="breadcrumb-link forcefocusAdd" href="" style={BreadCrombStyle} data-track={Content1}  aria-label={Content1}>{Content1}</a></li>
                        <li><span className="breadcrumb-arrow"/></li>
                        <li><span className="breadcrumb-link forcefocusAdd">{Content3 === "" || typeof Content3 === 'undefined' ? <span aria-label={Content2}  >{Content2}</span> :   <a href="#" aria-label={Content2}  >{Content2}</a>}    </span></li>
                        <li><span className={(Content3!==undefined)? "breadcrumb-arrow": "breadcrumb-arrow hide"}/></li>
                        <li><span className={(Content3!==undefined)? "breadcrumb-link": "breadcrumb-link hide"}  >{Content3}</span></li>
                     </ul>
            </div>
        </div>
</section>

export default BreadCrumb



// WEBPACK FOOTER //
// ./src/components/modules/BreadCrumb.js